import React from 'react'
import {useSearchParams} from 'react-router-dom'
import PageLayout from '../../../components/layout/PageLayout'
import LeagueDetailContainer from '../../../features/page/leaderboard/league/LeagueDetailContainer'

interface IProps {
    className?: string
}

const LeagueDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const leagueId = searchParams.get('id')

    return (
        <PageLayout title={'League Detail'} className={`${className}`}>
            <LeagueDetailContainer id={leagueId} />
        </PageLayout>
    )
}

export default LeagueDetailPage
